<script>
import appConfig from '@src/app.config'
import Breadcrumb from '@components/breadcrumbs'

import {
  apiClient,
  uploadVideoService,
  notificationService,
  helperService,
} from '@services'
import Loader from '@components/loader/loader'
import Multiselect from 'vue-multiselect'
import { VueEditor } from 'vue2-editor'
import VideoList from '@components/videoList/videoList'
import {
  CAMPAIGN_LIST,
  CAMPAIGN_TEST_EMAIL,
  GET_COMPAIGN,
  GET_MAIL_TEMPLATE,
  GET_PROJECT_BY_ID,
  SOCIAL_GOOGLE_ACCOUNT,
  CAMPAIGN_ID_VALIDATE,
  CAMPAIGN_ID,
  USER_ME,
} from '../../../constants/endponts'

export default {
  page: {
    title: 'Edit Campaign',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Breadcrumb,
    Loader,
    VideoList,
    VueEditor,
    Multiselect,
  },
  data() {
    return {
      VUE_APP_API_BASE_URL: process.env.VUE_APP_API_BASE_URL,
      breadcrumbs: [
        {
          name: 'Back to list of campaigns',
          path:
            '/projects/' + this.$route.params.projectId + '/email-campaigns',
        },
      ],
      projectId: this.$route.params.projectId,
      campaignId: this.$route.params.campaignId,
      page: 1,
      page_size: 100,
      secondaryLoading: false,
      campaignName: null,
      steps: [
        {
          name: 'generateList',
          selected: false,
        },
        {
          name: 'videosToSeach',
          selected: false,
          completed: false,
        },
        {
          name: 'subject',
          selected: false,
          completed: false,
        },
        {
          name: 'reviewAndEdit',
          selected: false,
          completed: false,
        },
      ],
      form: {
        companySize: [],
        subject: '',
        testEmail: '',
        intro: '',
        body: '',
        contactListId: null,
        mailTemplate: null,
      },
      customEditorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
      ],
      showGenerateListButton: false,
      generateListMessage: false,
      generatedList: false,
      fileData: null,
      previewImage: null,
      videos: [],
      videosNext: null, // url to next page with videos
      videoSelected: null,
      videoSkipped: null,
      itemSelectedId: null,
      emailSelected: [],
      max: 200,
      // here we have saved Campaign object
      campaign: null,
      campaignList: null,
      filterDict: {},
      generateListOnSave: false,
      closeOnSave: false,
      generateListDisabled: false,
      googleAccounts: null,
      smtpEmails: null,
      selectedSparkpostEmail: null,
      selectedGoogleAccounts: [], // user can select more than one account
      selectedSmtpEmail: null,
      loading: true,
      emailSending: false,
      campaignLists: null,
      mailTemplates: null,
      needSendTestEmail: true,
      sparkpostEmails: null,
      showDifferentAccounts: {
        gmail: false,
        sparkpost: false,
      },
      lockStartCampaignButton: false,
      validateCampaignLock: false,
      validationMatchedWords: null,
      validationMalicious: null,
      user: null,
    }
  },
  computed: {
    stepOne() {
      return this.campaign.campaign_list.length > 0
    },
    stepTwo() {
      return (
        this.selectedGoogleAccounts.length ||
        this.selectedSparkpostEmail ||
        this.selectedSmtpEmail
      )
    },
    stepThree() {
      return !!this.videoSelected
    },
    stepFour() {
      return this.form.subject.length > 0
    },
    currentCostWithVideo() {
      return (this.campaign.total_leads_count * 0.005).toFixed(2)
    },
    currentCostWithoutVideo() {
      return (this.campaign.total_leads_count * 0.015).toFixed(2)
    },
    currentCost() {
      if (this.videoSelected) {
        return this.currentCostWithVideo
      } else {
        return this.currentCostWithoutVideo
      }
    },
    currentCostDifference() {
      return (this.currentCostWithoutVideo - this.currentCostWithVideo).toFixed(
        2
      )
    },
    sendTestEmailsString() {
      if (this.selectedGoogleAccounts.length > 0) {
        let emails = []
        for (var i in this.selectedGoogleAccounts) {
          emails.push(this.selectedGoogleAccounts[i].account_email)
        }
        return emails.join(', ')
      }
      return ''
    },
  },
  watch: {
    form: {
      handler(val) {
        this.needSendTestEmail = true
      },
      deep: true,
    },
  },
  mounted() {
    Promise.all([
      this.getCampaignList(),
      this.getSparkpostEmails(),
      this.getGoogleAccounts(),
      this.getSmtpEmails(),
      this.getCampaign(),
      this.getVideos(),
      this.getMailTemplates(),
      this.getUserMe(),
    ]).then(() => {
      if (this.videoSelected) {
        this.selectVideo(this.campaign.content.id)
      }

      // select campaign list
      let campaignListId = this.$route.query.campaign_list_id
      if (campaignListId) {
        campaignListId = parseInt(campaignListId, 10)
        for (let index = 0; index < this.campaignLists.length; index++) {
          let item = this.campaignLists[index]
          if (item.id === campaignListId) {
            this.campaign.campaign_list.push(item)

            this.updateCampaign()
            break
          }
        }
      }

      // select google account
      // this.campaign.google_accounts is list with ids
      if (this.campaign && this.campaign.google_accounts.length) {
        for (let index = 0; index < this.googleAccounts.length; index++) {
          let item = this.googleAccounts[index]

          if (this.campaign.google_accounts.indexOf(item.id) !== -1) {
            this.selectedGoogleAccounts.push(item)
          }
        }
      }
      // select sparkpost account
      if (this.campaign && this.campaign.sparkpost_email) {
        for (let index = 0; index < this.sparkpostEmails.length; index++) {
          let item = this.sparkpostEmails[index]
          if (item.id === this.campaign.sparkpost_email) {
            this.selectedSparkpostEmail = item
            break
          }
        }
      }

      // select smtp email
      if (this.campaign && this.campaign.smtp_email) {
        for (let index = 0; index < this.smtpEmails.length; index++) {
          let item = this.smtpEmails[index]
          if (item.id === this.campaign.smtp_email) {
            this.selectedSmtpEmail = item
            break
          }
        }
      }

      if (this.campaign && this.campaign.mail_template) {
        for (let index = 0; index < this.mailTemplates.length; index++) {
          let item = this.mailTemplates[index]
          if (item.id === this.campaign.mail_template) {
            this.form.mailTemplate = item
            break
          }
        }
      }

      // Select first mail template
      if (this.mailTemplates && !this.form.mailTemplate) {
        this.form.mailTemplate = this.mailTemplates[0]
      }

      this.loading = false
    })
  },
  methods: {
    getUserMe() {
      return apiClient
        .get(USER_ME)
        .then((res) => {
          this.user = res.data
        })
        .catch((err) => {
          return err
        })
    },
    getCampaign() {
      return apiClient
        .get(CAMPAIGN_ID(this.campaignId))
        .then((res) => {
          this.campaign = res.data
          this.form.subject = this.campaign.subject
          this.form.intro = this.campaign.intro
          this.form.body = this.campaign.body

          if (this.campaign.content) {
            this.selectVideo(this.campaign.content.id)
            this.videoSelected = true
          }

          if (this.campaign && this.campaign.campaign_list) {
            this.generatedList = true
          }
        })
        .catch((err) => {
          return err
        })
    },
    showGenerateList(e) {
      const element = e.target
      element.classList.add('active', 'text-white')
      this.showGenerateListButton = true
    },
    chooseImage(event) {
      event.preventDefault()
      this.$refs.fileInput.click()
    },
    onFileChange(e) {
      const reader = new FileReader()
      const input = this.$refs.fileInput
      const files = input.files
      reader.onload = (e) => {
        this.fileData = e.target.result
        this.previewImage = reader.result
      }
      reader.readAsDataURL(files[0])
      this.$emit('input', files[0])
    },
    onSelectFile(fileInput) {
      const input = this.$refs[fileInput]
      const files = input.files
      const callback = () => {
        this.getVideos()
        this.$forceUpdate()
      }

      if (files && files[0]) {
        const videoName = files[0].name
          .split('.')
          .slice(0, -1)
          .join('.')
        let formData = new FormData()
        formData.append('title', videoName)

        this.secondaryLoading = true

        uploadVideoService.upload(
          this.VUE_APP_API_BASE_URL,
          this.projectId,
          files[0],
          callback,
          formData
        )

        const reader = new FileReader()
        if (files[0].type.match('image')) {
          reader.onload = (e) => {
            this.previewImage = reader.result
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        } else {
          reader.onload = (e) => {
            let blob = new Blob([reader.result], { type: files[0].type })
            let url = URL.createObjectURL(blob)
            let video = document.createElement('video')

            let timeupdate = () => {
              if (image()) {
                video.removeEventListener('timeupdate', timeupdate)
                video.pause()
              }
            }

            video.addEventListener('loadeddata', () => {
              if (image()) {
                video.removeEventListener('timeupdate', timeupdate)
              }
            })

            let image = () => {
              let canvas = document.createElement('canvas')
              canvas.width = video.videoWidth
              canvas.height = video.videoHeight
              canvas
                .getContext('2d')
                .drawImage(video, 0, 0, canvas.width, canvas.height)
              let image = canvas.toDataURL()
              let success = image.length > 100000
              if (success) {
                let img = document.createElement('img')
                img.src = image
                this.previewImage = image
                URL.revokeObjectURL(url)
              }
              return success
            }
            video.addEventListener('timeupdate', timeupdate)
            video.preload = 'metadata'
            video.src = url
            video.muted = true
            video.playsInline = true
            video.play()
          }
          reader.readAsArrayBuffer(files[0])
        }
      }
    },
    getVideos() {
      return apiClient
        .get(
          GET_PROJECT_BY_ID(this.projectId) +
            'content/?page_size=' +
            this.page_size
        )
        .then((res) => {
          this.videos = res.data.results
          this.videosNext = res.data.next
          this.secondaryLoading = false
        })
        .catch((err) => {
          this.secondaryLoading = false
          return err
        })
    },
    getCampaignList() {
      // localhost:8080/projects/45843/campaign/41#campaign_list_id=50
      return apiClient
        .get(CAMPAIGN_LIST, { params: { page_size: 200 } })
        .then((res) => {
          this.campaignLists = res.data.results
        })
        .catch((err) => {
          return err
        })
    },
    getMailTemplates() {
      return apiClient
        .get(GET_MAIL_TEMPLATE)
        .then((res) => {
          this.mailTemplates = res.data.results
        })
        .catch((err) => {
          return err
        })
    },
    selectVideo(id) {
      if (id) {
        id = id.toString()
      }

      const index = this.videos.findIndex((i) => {
        return i.id === Number(id)
      })

      if (id == null) {
        this.videoSelected = null
        this.itemSelectedId = id
      } else {
        if (this.videoSelected && Number(id) === this.videoSelected.id) {
          this.itemSelectedId = ''
          this.videoSelected = null
        } else {
          this.videoSelected = this.videos[index]
          this.itemSelectedId = id
        }
      }
    },
    selectCampaignList() {
      // refresh list
      if (this.campaign.campaign_list.length > 0) {
        this.stepOne = true
      } else {
        this.stepOne = false
      }
      this.$nextTick(() => {
        // TODO: start only after timeout
        this.updateCampaign()
        this.generatedList = true
      })
    },
    nextStep() {
      this.steps[1].selected = false
      this.steps[2].selected = true
    },
    getCampaignData() {
      let data = {
        app_id: this.projectId,
        name: this.campaign.name,
        subject: this.form.subject,
        intro: this.form.intro,
        body: this.form.body,
        reply_to: this.campaign.reply_to,
        campaign_list_id: this.campaign.campaign_list.map((i) => {
          return i.id
        }),
      }

      if (this.form.mailTemplate) {
        data.mail_template = this.form.mailTemplate.id
      }

      if (this.itemSelectedId != null) {
        data.content_id = this.itemSelectedId
      }

      // set first google account by default
      let googleAccounts = []
      if (this.selectedGoogleAccounts.length > 0) {
        for (var i in this.selectedGoogleAccounts) {
          googleAccounts.push(this.selectedGoogleAccounts[i].id)
        }
      }
      data.google_accounts = googleAccounts

      if (this.selectedSparkpostEmail) {
        data.sparkpost_email = this.selectedSparkpostEmail.id
      } else {
        data.sparkpost_email = null
      }

      if (this.selectedSmtpEmail) {
        data.smtp_email = this.selectedSmtpEmail.id
      } else {
        data.smtp_email = null
      }

      return data
    },
    saveCampaign() {
      return apiClient
        .post(GET_COMPAIGN, this.getCampaignData())
        .then(
          (res) => {
            this.campaign = res.data
            notificationService.success('Campaign saved')
            if (this.closeOnSave) {
              this.close()
            }
            return res
          },
          (err) => {
            notificationService.handleResponse(err.response)
          }
        )
        .catch((err) => {
          return err
        })
    },
    updateCampaign() {
      return apiClient
        .patch(CAMPAIGN_ID(this.campaign.id), this.getCampaignData())
        .then(
          (res) => {
            this.campaign = res.data
            notificationService.success('Campaign updated')
            return res
          },
          (err) => {
            notificationService.handleResponse(err.response)
          }
        )
    },
    validateCampaign() {
      this.validateCampaignLock = true
      this.updateOrCreateCampaign().then(() => {
        apiClient.post(CAMPAIGN_ID_VALIDATE(this.campaign.id)).then(
          (res) => {
            notificationService.success('Mail validated')
            this.validationMatchedWords = res.data.matched_words
            this.validationMalicious = res.data.malicious
            this.validateCampaignLock = false
          },
          () => {
            this.validateCampaignLock = false
          }
        )
      })
    },
    startCampaign() {
      if (window.confirm('Everything looks good?')) {
        this.lockStartCampaignButton = true
        this.updateOrCreateCampaign().then(() => {
          let url =
            this.VUE_APP_API_BASE_URL +
            '/api/v1/campaign/' +
            this.campaign.id +
            '/'

          apiClient
            .patch(url, {
              status: 1, // Set status as ongoing
            })
            .then(
              (res) => {
                notificationService.success('Campaign started')
                // redirect here
                this.$router.push(
                  '/projects/' + this.projectId + '/email-campaigns'
                )
              },
              (err) => {
                notificationService.handleResponse(err.response)
                this.lockStartCampaignButton = false
              }
            )
        })
      }
    },
    updateOrCreateCampaign() {
      if (this.campaign === null) {
        return this.saveCampaign()
      } else {
        return this.updateCampaign()
      }
    },
    openPreviewCampaignLink() {
      let previewUrl = this.VUE_APP_API_BASE_URL + this.campaign.preview_url

      window.open(previewUrl, '_blank')
    },
    previewCampaign() {
      this.updateOrCreateCampaign().then(() => {
        this.openPreviewCampaignLink()
        this.needSendTestEmail = false
      })
    },
    openEpisodeLink() {
      let url =
        'https://dashboard.alphavoice.io/projects/' +
        this.projectId +
        '/episode/' +
        this.videoSelected.id +
        '/edit'
      // todo: Change this external link from numbers to slugs. ... let url = "https://www.alphavoice.io" + this.episodeInfo.external_url
      window.open(url, '_blank')
    },
    saveCampaignList(data) {
      let url =
        this.VUE_APP_API_BASE_URL +
        '/api/v1/campaign/' +
        this.campaign.id +
        '/list/'
      return apiClient
        .post(url, data)
        .then((res) => {
          this.campaignList = res.data
          return res
        })
        .catch((err) => {
          return err
        })
    },
    updateCampaignList(listId, data) {
      let url =
        this.VUE_APP_API_BASE_URL +
        '/api/v1/campaign/' +
        this.campaign.id +
        '/list/' +
        listId +
        '/'
      return apiClient
        .patch(url, data)
        .then((res) => {
          this.campaignList = res.data
          return res
        })
        .catch((err) => {
          return err
        })
    },
    close() {
      this.$router.push('/projects/' + this.projectId + '/email-campaigns')
    },
    saveAndClose() {
      this.closeOnSave = true
      if (this.campaignName && !this.campaign) {
        this.saveCampaign()
          .then((res) => {
            this.close()
          })
          .catch((err) => {
            return err
          })
      } else {
        if (this.campaign) {
          // update campaing
          // Campaign list saves only when user click to generate lead data
          this.updateCampaign().then(() => {
            this.close()
          })
        } else {
          this.modalAction('open')
        }
      }
    },
    saveAndAttach() {
      if (this.campaignName && !this.campaign) {
        this.saveCampaign()
          .then((res) => {
            this.$router.push('/profile')
          })
          .catch((err) => {
            return err
          })
      } else {
        if (this.campaign) {
          // update campaing
          // Campaign list saves only when user click to generate lead data
          this.updateCampaign().then(() => {
            this.$router.push('/profile')
          })
        } else {
          this.modalAction('open')
        }
      }
    },
    saveAndAttachGoogle() {
      this.saveCampaign().then(() => {
        this.linkGoogleAccount()
      })
    },
    saveAndAttachSparkPost() {
      this.saveAndAttach()
    },
    saveAndAttachSmtp() {
      this.saveAndAttach()
    },
    getGoogleAccounts() {
      return apiClient
        .get(SOCIAL_GOOGLE_ACCOUNT)
        .then((res) => {
          this.googleAccounts = res.data.results
        })
        .catch((err) => {
          return err
        })
    },
    modalAction(action) {
      if (action === 'open') {
        this.$refs.modal.open()
      } else {
        this.$refs.modal.close()
      }
    },
    linkGoogleAccount() {
      let returnUrl = ''
      if (this.VUE_APP_API_BASE_URL === 'http://localhost:8000') {
        returnUrl = 'http://localhost:8080'
      } else {
        returnUrl = 'https://dashboard.alphavoice.io'
      }

      let url =
        this.VUE_APP_API_BASE_URL +
        '/accounts/google/login/?process=connect&next=' +
        encodeURI(returnUrl + this.$route.path)

      helperService
        .getSession({
          url: url,
        })
        .then((response) => {
          let key = response.data.key
          let redirectUrl =
            this.VUE_APP_API_BASE_URL +
            helperService.getSessionUrl() +
            '?key=' +
            key
          window.open(redirectUrl, '_self')
        })
    },
    getSparkpostEmails() {
      return helperService.getSparkPostEmails().then((res) => {
        this.sparkpostEmails = res.data.results
        return res
      })
    },
    openProspects() {
      // /projects/:projectId/prospects
      this.$router.push(
        '/projects/' +
          this.projectId +
          '/prospects?campaign_list=' +
          this.campaignId
      )
    },
    importList() {
      // /projects/:projectId/prospects
      this.$router.push(
        '/contacts/import?campaign_list=' +
          this.campaignId +
          '&app_id=' +
          this.projectId
      )
    },
    sendTestEmail() {
      this.emailSending = true

      this.updateOrCreateCampaign().then(() => {
        apiClient
          .post(CAMPAIGN_TEST_EMAIL, {
            campaign_id: this.campaign.id,
            email: this.form.testEmail,
          })
          .then((res) => {
            this.emailSending = false
            this.needSendTestEmail = false
            notificationService.success(
              'Mail sent successfully. Please check your mailbox'
            )
          })
          .catch((err) => {
            notificationService.handleResponse(err.response)
            this.emailSending = false
            return err
          })
      })
    },
    getSmtpEmails() {
      return helperService.getSmtpEmails().then((res) => {
        this.smtpEmails = res.data.results
        return res
      })
    },
    save() {
      this.updateOrCreateCampaign().then(() => {})
    },
    selectEmail(emailClient, email) {
      if (emailClient === 'google') {
        if (
          this.selectedGoogleAccounts.filter(
            (i) => i.account_email === email.account_email
          ).length
        ) {
          for (var i in this.selectedGoogleAccounts) {
            if (this.selectedGoogleAccounts.hasOwnProperty(i)) {
              if (
                this.selectedGoogleAccounts[i].account_email ===
                email.account_email
              ) {
                delete this.selectedGoogleAccounts[i]
                this.selectedGoogleAccounts.splice(i, 1)
              }
            }
          }
        } else {
          var arr = this.googleAccounts.filter(
            (i) => i.account_email === email.account_email
          )
          this.selectedGoogleAccounts = this.selectedGoogleAccounts.concat(arr)
        }
      }
      if (emailClient === 'smtp') {
        this.selectedSmtpEmail = email
      }
      if (emailClient === 'sparkpost') {
        this.selectedSparkpostEmail = email
      }
    },
    gmailStep() {
      this.sendWithGmail.step = this.sendWithGmail.step + 1
    },
    defaultEmail(emailClient) {
      this.selectedGoogleAccounts = []
      this.selectedSparkpostEmail = null
      this.selectedSmtpEmail = null

      if (emailClient === 'google') {
        if (this.googleAccounts[0]) {
          this.selectedGoogleAccounts.push(this.googleAccounts[0])
        }
      } else if (emailClient === 'sparkpost') {
        if (this.sparkpostEmails[0]) {
          this.selectedSparkpostEmail = this.sparkpostEmails[0]
        }
      } else if (emailClient === 'smtp') {
        if (this.smtpEmails[0]) {
          this.selectedSmtpEmail = this.smtpEmails[0]
        }
      }
    },
    googleAccountIsSelected(item) {
      return (
        this.selectedGoogleAccounts.filter((i) => i.id === item.id).length > 0
      )
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div class="create-campaign">
    <div class="topbar bg-dark">
      <div class="d-flex align-items-center justify-content-between container">
        <Breadcrumb
          :show-back-arrows="true"
          :list="breadcrumbs"
          class="text-gray-input gray-breadcrumbs"
        />
        <div>
          <button
            class="btn btn-outline-secondary border-0"
            @click="saveAndClose"
            >Save & Finish later</button
          >
          <!-- <button class="btn btn-outline-gray border-0">Draft</button> -->
        </div>
      </div>
    </div>

    <div v-if="campaign" class="container py-4">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label for="projectName">
              <small>Campaign name</small>
            </label>
            <BaseInputText
              v-model="campaign.name"
              name="campaignName"
              :placeholder="`Enter your title here`"
            />
          </div>

          <p class="font-weight-light"
            >Edit email campaign for project
            <strong>{{ campaign.app.name }}</strong></p
          >
        </div>
        <div class="col"> </div>
      </div>

      <div id="stepsGroup" class="card mb-4 overflow-initial steps-group">
        <div class="py-3 px-3 step-box">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="mr-2">
                <img
                  v-if="stepOne"
                  src="@assets/images/icons/grey-check.svg"
                  alt=""
                />
                <img v-else src="@assets/images/icons/white-check.svg" alt="" />
              </span>
              <p class="mt-1 mb-0 font-weight-bold">To who is this campaign?</p>
            </div>
            <button
              class="btn btn-primary font-weight-normal px-4 btn-collapse"
              data-toggle="collapse"
              href="#collapseExample"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
              >Create your list</button
            >
          </div>
          <div id="collapseExample" class="collapse" data-parent="#stepsGroup">
            <div class="card card-body step-one ">
              <p class="text-center font-weight-light">Do you want to</p>
              <div
                class="d-flex align-items-top justify-content-center pb-4 mb-2 list-options"
              >
                <button
                  id="generateList"
                  class="btn btn-outline-secondary btn-generate-list"
                  :disabled="campaign.status === 3"
                  @click.prevent="openProspects"
                >
                  <span class="text-secondary-light">
                    <BaseIcon name="plus" />
                  </span>
                  Generate a List
                </button>
                <p class="text-center font-weight-light my-0 mx-3 mt-2">or</p>
                <button
                  id="generateList"
                  class="btn btn-outline-secondary btn-generate-list"
                  :disabled="campaign.status === 3"
                  @click.prevent="importList"
                >
                  <span class="text-secondary-light">
                    <BaseIcon name="plus" />
                  </span>
                  Import a List
                </button>
                <p class="text-center font-weight-light my-0 mx-3 mt-2">or</p>
                <div
                  v-if="campaign && campaignLists"
                  class="input-group px-0 my-0 lists-created"
                >
                  <Multiselect
                    v-model="campaign.campaign_list"
                    deselect-label="Remove"
                    class="location-select"
                    open-direction="bottom"
                    :options="campaignLists"
                    :multiple="true"
                    track-by="id"
                    label="name"
                    :close-on-select="true"
                    :disabled="campaign.status === 3"
                    placeholder="Select a lists..."
                    @select="selectCampaignList"
                    @remove="selectCampaignList"
                  />
                </div>

                <!-- <router-link
                  tag="button"
                  to="#"
                  class="btn btn-outline-secondary"
                > -->
                <!-- <router-link
                  tag="button"
                  :to="{
                    name: 'Prospects',
                    params: { projectId: projectId },
                  }"
                 class="btn btn-outline-secondary"
                >
                  <span class="text-secondary-light">
                    <BaseIcon name="upload" />
                  </span>
                  Upload a List
                </router-link> -->
              </div>
              <div
                v-if="campaign.total_leads_count > 0"
                class="text-center pb-4 mb-2"
              >
                <h3 class="mb-0">
                  We found
                  <span>{{ campaign.total_leads_count }}</span> emails
                </h3>
              </div>
              <div v-if="showGenerateListButton" class="generate-list">
                <!-- <div v-if="form.companySize.length > 0">
                  <hr class="col-sm-10 mx-auto my-0 pb-2" />

                  <div
                    v-if="generateListMessage"
                    class="result-message text-center mt-3"
                  >
                    <h2>
                      With the selected filter we found
                      <span class="text-purple">{{campaign.total_leads_count}}</span> leads
                    </h2>
                     <small class="text-center"
                      >Email 2,390 of your 5,000 monthly leads</small
                    >
                  </div>

                  <button
                    class="btn btn-primary d-block mx-auto my-4"
                    :disabled="generateListDisabled"
                    @click.prevent="generateList"
                    >Generate list</button
                  >
                </div>  <div class="text-center">
                  <h3 v-if="campaign && campaign.total_leads_count > 0" class="mb-0"
                    >We found around
                    <span>{{ campaign.total_leads_count }}</span>
                    emails</h3
                  ></div
                > -->
              </div>
            </div>
          </div>
        </div>

        <!-- Step TWO -->
        <div class="py-3 px-3 step-box">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="mr-2">
                <img
                  v-if="
                    stepTwo ||
                      selectedGoogleAccounts.length ||
                      selectedSparkpostEmail ||
                      selectedSmtpEmail
                  "
                  src="@assets/images/icons/grey-check.svg"
                  alt=""
                />
                <img v-else src="@assets/images/icons/white-check.svg" alt="" />
              </span>
              <p class="mt-1 mb-0 font-weight-bold"
                >Who are you sending from?</p
              >
            </div>
            <button
              class="btn font-weight-normal px-4"
              :class="
                stepTwo ||
                selectedGoogleAccounts.length ||
                selectedSparkpostEmail ||
                selectedSmtpEmail
                  ? 'btn-primary'
                  : 'btn-outline-gray'
              "
              data-toggle="collapse"
              href="#emailAddress"
              role="button"
              aria-expanded="false"
              aria-controls="emailAddress"
              :disabled="
                !stepOne &&
                selectedGoogleAccounts.length === 0 &&
                !selectedSparkpostEmail
                  ? true
                  : false
              "
              >Choose an email address</button
            >
          </div>

          <div id="emailAddress" class="collapse" data-parent="#stepsGroup">
            <div
              id="emailOptions"
              class="card card-body step-one email-options"
            >
              <p class="text-center font-weight-light"
                >You can send to {{ campaign.total_leads_count }} recipients
              </p>
              <div
                class="d-flex align-items-top justify-content-center pb-4 mb-2"
              >
                <div>
                  <button
                    id="sendWithSparkpost"
                    class="btn btn-collapse px-4"
                    :class="!selectedSparkpostEmail && 'collapsed'"
                    data-toggle="collapse"
                    href="#emailAddressSparkpost"
                    role="button"
                    :aria-expanded="selectedSparkpostEmail ? true : false"
                    aria-controls="emailAddressSparkpost"
                    @click="defaultEmail('sparkpost')"
                  >
                    Send with Sparkpost
                  </button>
                  <p class="mb-0 mt-1 text-center">
                    <small class="font-italic font-wwight-light"
                      >15,000 emails/day</small
                    >
                  </p>
                </div>

                <p class="text-center font-weight-light my-0 mx-3 mt-2">or</p>

                <div>
                  <button
                    id="sendWithGmail"
                    class="btn btn-collapse px-4"
                    :class="selectedGoogleAccounts.length === 0 && 'collapsed'"
                    data-toggle="collapse"
                    href="#emailAddressGmail"
                    role="button"
                    :aria-expanded="selectedGoogleAccounts.length > 0"
                    aria-controls="emailAddressGmail"
                    @click="defaultEmail('google')"
                  >
                    Send with Gmail
                  </button>
                  <div class="mb-0 mt-1 text-center">
                    <small class="font-italic font-wwight-light"
                      >400 emails/day</small
                    >
                  </div>
                </div>

                <p class="text-center font-weight-light my-0 mx-3 mt-2">or</p>

                <div>
                  <button
                    id="sendWithSMTP"
                    class="btn btn-collapse px-4"
                    :class="!selectedSmtpEmail && 'collapsed'"
                    data-toggle="collapse"
                    href="#emailAddressSMTP"
                    role="button"
                    :aria-expanded="selectedSmtpEmail ? true : false"
                    aria-controls="emailAddressSMTP"
                    @click="defaultEmail('smtp')"
                  >
                    Send with SMTP
                  </button>
                  <!-- <div class="mb-0 mt-1 text-center">
                    <small class="font-italic font-wwight-light"
                      >200 emails/day</small
                    >
                  </div> -->
                </div>
              </div>

              <!-- Sparkpost -->
              <div
                id="emailAddressSparkpost"
                class="emails-container py-3 px-4"
                :class="!selectedSparkpostEmail && 'collapse'"
                data-parent="#emailOptions"
              >
                <div
                  v-if="
                    selectedSparkpostEmail && selectedSparkpostEmail.length <= 0
                  "
                >
                  <small class="text-center font-italic d-block mx-auto">
                    Your SparkPost email account not been linked
                  </small>

                  <div>
                    <button
                      class="btn btn-orange-dark d-block mx-auto px-4 my-4"
                      @click.prevent="saveAndAttachSparkPost"
                    >
                      <BaseIcon name="envelope" class="mr-2" />
                      Save & Attach your Sparkpost Account
                    </button>
                  </div>
                </div>

                <div v-else>
                  <h5 class="text-center mt-3 mb-4">
                    Choose your email
                  </h5>

                  <div>
                    <div
                      v-for="(item, index) in sparkpostEmails"
                      :key="index"
                      class="sparkpost-email text-center p-2 mb-3 mx-auto"
                      :class="
                        selectedSparkpostEmail &&
                          selectedSparkpostEmail.email === item.email &&
                          'selected'
                      "
                      @click="selectEmail('sparkpost', item)"
                    >
                      <small
                        class="font-italic font-weight-light"
                        :class="
                          selectedSparkpostEmail &&
                          item.email === selectedSparkpostEmail.email
                            ? 'text-gray'
                            : 'text-gray-light'
                        "
                        >{{ item.email }}</small
                      >
                    </div>
                  </div>

                  <p class="text-center">
                    <small class=" font-weight-light"> or </small>
                  </p>

                  <div>
                    <button
                      class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                      @click.prevent="saveAndAttachSparkPost"
                    >
                      Save & Attach a different Account
                    </button>

                    <button
                      class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                      data-toggle="collapse"
                      href="#videoToSearch"
                      role="button"
                      aria-expanded="false"
                      aria-controls="videoToSearch"
                      >Continue
                    </button>
                  </div>
                </div>
              </div>

              <!-- GMAIL -->
              <div
                id="emailAddressGmail"
                class="emails-container py-3 px-4"
                :class="selectedGoogleAccounts.length === 0 && 'collapse'"
                data-parent="#emailOptions"
              >
                <div v-if="googleAccounts.length <= 0">
                  <small class="text-center font-italic d-block mx-auto">
                    Your email account not been linked
                  </small>

                  <div>
                    <button
                      class="btn btn-orange-dark d-block mx-auto px-4 my-4"
                      @click.prevent="saveAndAttachGoogle"
                    >
                      <BaseIcon name="envelope" class="mr-2" />
                      Save & Attach your Gmail Account
                    </button>
                  </div>
                </div>

                <div v-else class="pt-0 pb-3 px-4">
                  <div>
                    <div v-if="!showDifferentAccounts.gmail">
                      <h5 class="text-center mt-3 mb-4">
                        Send with
                      </h5>

                      <div v-if="googleAccounts">
                        <div
                          v-for="(item, index) in googleAccounts"
                          :key="index"
                          class="gmail-email mb-3 mx-auto"
                          :class="googleAccountIsSelected(item) && 'selected'"
                          @click="selectEmail('google', item)"
                        >
                          <div class="d-flex align-items-top p-2">
                            <small class="gmail-pic mr-3 p">
                              <img
                                src="@assets/images/icons/user-icon.svg"
                                alt=""
                                class="w-100"
                              />
                            </small>
                            <div class="info d-flex align-items-center">
                              <!-- <small class="font-weight-bold">{{items[0].name}}</small> -->
                              <small
                                class="font-weight-light text-gray d-block info-email"
                                >{{ item.account_email }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--
                  <div v-if="this.selectedGoogleAccounts.length>1">
                    <div v-if="!showDifferentAccounts.gmail">
                      <h5 class="text-center mt-3 mb-4">
                        All emails will reply to this 1 address
                      </h5>

                      <div v-if="googleAccounts">
                        <div
                          v-for="(item, index) in googleAccounts"
                          :key="index"
                          class="gmail-email mb-3 mx-auto"
                          :class="
                            selectedGoogleAccount &&
                              selectedGoogleAccount.account_email ===
                                item.account_email &&
                              'selected'
                          "
                          @click="selectEmail('google', item)"
                        >
                          <div class="d-flex align-items-top p-2">
                            <small class="gmail-pic mr-3 p">
                              <img
                                src="@assets/images/icons/user-icon.svg"
                                alt=""
                                class="w-100"
                              />
                            </small>
                            <div class="info d-flex align-items-center">
                               <small class="font-weight-bold">{{items[0].name}}</small>
                              <small
                                class="font-weight-light text-gray d-block info-email"
                                >{{ item.account_email }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  -->

                  <div
                    v-if="selectedGoogleAccounts.length > 1"
                    class="bg-white px-5 pt-4 pb-2"
                  >
                    <div class="row">
                      <div class="col-sm-12 col-md-10 mx-auto">
                        <h5 class="text-center mt-3 mb-4">
                          {{ selectedGoogleAccounts.length }} emails selected
                        </h5>
                        <h5 class="text-center mt-3 mb-4">
                          All emails will reply to this 1 email address
                        </h5>
                        <div class="mb-3">
                          <BaseInputText
                            v-model="campaign.reply_to"
                            name="replyTo"
                            type="text"
                            placeholder="Email for Reply-to"
                            aria-label="replyTo"
                            aria-describedby="basic-addon2"
                            class="form-control"
                          />
                        </div>
                        <!--<p><br/>Email will be used in Reply-To field.</p>-->
                      </div>
                    </div>
                  </div>

                  <p class="text-center">
                    <small class=" font-weight-light"> or </small>
                  </p>

                  <div>
                    <button
                      class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                      @click.prevent="saveAndAttachGoogle"
                    >
                      Save & Attach a different Account
                    </button>

                    <button
                      class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                      data-toggle="collapse"
                      href="#videoToSearch"
                      role="button"
                      aria-expanded="false"
                      aria-controls="videoToSearch"
                      >Continue
                    </button>
                  </div>
                </div>
              </div>

              <!-- SMTP -->
              <div
                id="emailAddressSMTP"
                class="emails-container py-3 px-4"
                :class="!selectedSmtpEmail && 'collapse'"
                data-parent="#emailOptions"
              >
                <div v-if="selectedSmtpEmail && selectedSmtpEmail.length <= 0">
                  <small class="text-center font-italic d-block mx-auto">
                    Your SMTP email account not been linked
                  </small>

                  <div>
                    <button
                      class="btn btn-orange-dark d-block mx-auto px-4 my-4"
                      @click.prevent="saveAndAttachSmtp"
                    >
                      <BaseIcon name="envelope" class="mr-2" />
                      Save & Attach your SMTP Account
                    </button>
                  </div>
                </div>

                <div v-else>
                  <h5 class="text-center mt-3 mb-4">
                    Choose your email
                  </h5>

                  <div>
                    <div
                      v-for="(item, index) in smtpEmails"
                      :key="index"
                      class="sparkpost-email text-center p-2 mb-3 mx-auto"
                      :class="
                        selectedSmtpEmail &&
                          selectedSmtpEmail.email === item.email &&
                          'selected'
                      "
                      @click="selectEmail('smtp', item)"
                    >
                      <small
                        class="font-italic font-weight-light"
                        :class="
                          selectedSmtpEmail &&
                          item.email === selectedSmtpEmail.email
                            ? 'text-gray'
                            : 'text-gray-light'
                        "
                        >{{ item.email }}</small
                      >
                    </div>
                  </div>

                  <p class="text-center">
                    <small class=" font-weight-light"> or </small>
                  </p>

                  <div>
                    <button
                      class="btn btn-outline-secondary border-0 d-block mx-auto px-0 mt-2 font-weight-light btn-save-attach"
                      @click.prevent="saveAndAttachSmtp"
                    >
                      Save & Attach a different Account
                    </button>

                    <button
                      class="btn btn-secondary d-block mx-auto px-5 py-1 mt-5 mb-4 py font-weight-light"
                      data-toggle="collapse"
                      href="#videoToSearch"
                      role="button"
                      aria-expanded="false"
                      aria-controls="videoToSearch"
                      >Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP THREE  -->
        <div class="step-box">
          <div class="py-3 px-3 ">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span class="mr-2">
                  <img
                    v-if="stepThree"
                    src="@assets/images/icons/grey-check.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="@assets/images/icons/white-check.svg"
                    alt=""
                  />
                </span>
                <p class="mt-1 mb-0 font-weight-bold"
                  >Which videos would you like to search?</p
                >
              </div>

              <button
                class="btn font-weight-normal px-4 btn-collapse"
                :class="stepThree ? 'btn-primary' : 'btn-outline-gray'"
                data-toggle="collapse"
                href="#videoToSearch"
                role="button"
                aria-expanded="false"
                aria-controls="videoToSearch"
                :disabled="!stepThree ? true : false"
                >Select your video</button
              >
            </div>
          </div>
          <div id="videoToSearch" class="collapse" data-parent="#stepsGroup">
            <div class="py-3 px-3 ">
              <div
                class="d-flex align-items-center justify-content-between mt-3 mb-0"
              >
                <small class="text-left font-weight-light"
                  >Select your video</small
                >

                <!-- <div class="modal-upload-file">
                  <label for="file-upload" class="custom-file-upload btn border-0 text-purple m-0">
                    <span class="mr-1"><BaseIcon name="upload"/></span>
                    <small>Upload video instead</small>
                  </label>
                  <input
                    id="file-upload"
                    ref="fileInputInstead"
                    type="file"
                    @input="onSelectFile('fileInputInstead')"
                  />
                </div>-->
              </div>

              <div class="card card-body position-relative pt-0">
                <div
                  v-if="secondaryLoading"
                  class="add-episode__loader add-episode__loader--save position-absolute w-100 h-100"
                >
                  <Transition appear>
                    <div class="spinner-container">
                      <Loader />
                    </div>
                  </Transition>
                </div>

                <div
                  v-if="videos.length <= 0"
                  class="container upload mb-4 pt-4 pb-2"
                >
                  <!--UPLOAD-->
                  <form enctype="multipart/form-data" novalidate>
                    <div class="dropbox">
                      <div class="form-group h-100">
                        <div
                          id="uploadFile"
                          class="upload-container h-100"
                          :class="!previewImage && 'py-5'"
                        >
                          <div
                            class="upload-input w-100 h-100"
                            :style="{
                              'background-image': `url(${previewImage})`,
                            }"
                          >
                            <div
                              v-if="!fileData"
                              class="upload-placeholder d-flex justify-content-center align-items-center bg-transparent position-relative"
                            >
                              <div class="w-100">
                                <img
                                  src="@assets/images/upload.png"
                                  alt=""
                                  class="mb-3"
                                />
                                <br />
                                <div class="text-center mt-5 mb-4">
                                  <p class="w-25 mx-auto">
                                    Drag and drop your video here, or use the
                                    button bellow
                                  </p>

                                  <div class="modal-upload-file">
                                    <label
                                      for="file-upload"
                                      class="custom-file-upload m-0 btn btn-secondary"
                                      @click="chooseImage"
                                    >
                                      Upload a video
                                    </label>
                                    <input
                                      id="file-upload"
                                      ref="fileInput"
                                      type="file"
                                      @change="onFileChange"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <input
                              ref="fileInput"
                              class="file-input"
                              type="file"
                              @change="onFileChange"
                              @input="onSelectFile('fileInput')"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div v-else>
                  <div class="videos-container modal-videos__container my-4">
                    <VideoList
                      v-if="videos"
                      :videos="videos"
                      :zoom="false"
                      :select-video="selectVideo"
                      :upload-videos="true"
                      :select-manually="true"
                      :id-selected="itemSelectedId"
                      :campaign-selection="true"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="bg-dark p-3 d-flex alignt-items-center justify-content-end"
            >
              <!-- <button
                class="btn"
                :class="
                  stepTwo ? 'btn-primary' : 'btn-outline-gray'
                "
                :disabled="!stepTwo ? true : false"
                data-toggle="collapse"
                href="#reviewAndEdit"
                role="button"
                aria-expanded="false"
                aria-controls="reviewAndEdit"
              >
                Continue
              </button> -->
              <button
                class="btn btn-primary"
                data-toggle="collapse"
                href="#reviewAndEdit"
                role="button"
                aria-expanded="false"
                aria-controls="reviewAndEdit"
                @click="videoSkipped = true"
              >
                Continue
              </button>
            </div>
          </div>
        </div>

        <!-- STEP FOUR -->
        <div class="py-3 px-3 step-box">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="mr-2">
                <img
                  v-if="stepThree"
                  src="@assets/images/icons/grey-check.svg"
                  alt=""
                />
                <img v-else src="@assets/images/icons/white-check.svg" alt="" />
              </span>
              <p class="mt-1 mb-0 font-weight-bold"
                >Review and edit the content for your email</p
              >
            </div>

            <button
              class="btn btn-outline-gray font-weight-normal btn-collapse"
              data-toggle="collapse"
              href="#reviewAndEdit"
              role="button"
              aria-expanded="false"
              aria-controls="reviewAndEdit"
              :disabled="!stepThree ? true : false"
              >Review and design your email</button
            >
          </div>
          <div id="reviewAndEdit" class="collapse" data-parent="#stepsGroup">
            <div class="card card-body">
              <div class="bg-light px-5 py-4">
                <div class="row">
                  <div class="col-sm-12 col-md-10 mx-auto">
                    <h3>Let's create your email</h3>

                    <div class="card px-3 py-4">
                      <div
                        v-if="
                          campaign.campaign_list_variables &&
                            Object.keys(campaign.campaign_list_variables)
                              .length > 0
                        "
                        class="d-flex align-items-center subject-variables mb-3"
                      >
                        <small class="font-weight-light mr-2">Variables</small>
                        <span
                          v-for="(v, index) in campaign.campaign_list_variables"
                          :key="index"
                          class="badge badge-secondary bg-white border border-secondary text-secondary p-1 mr-2"
                        >
                          <span v-pre>{</span>{{ v }}<span v-pre>}</span>
                        </span>
                      </div>

                      <div
                        class="d-flex align-items-center subject-variables mb-3"
                      >
                        <small class="font-weight-bold mr-2"
                          >Subject Line</small
                        >
                      </div>

                      <div class="form-group">
                        <BaseInputText
                          v-model="form.subject"
                          name="subject"
                          type="text"
                          :placeholder="''"
                          class="mb-1"
                          :maxlength="max"
                        />
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <router-link tag="a" to="#">
                            <small class="text-purple font-weight-light">
                              How do I write a good subject line?
                            </small>
                          </router-link>

                          <small
                            class="input-group-addon text-gray-input"
                            v-text="
                              max - form.subject.length + ' characters left'
                            "
                          ></small>
                        </div>
                        <!-- <button class="btn btn-outline-gray-input px-4 d-block mx-auto my-4">Save</button> -->
                      </div>

                      <small class="font-weight-bold mr-2"
                        >Intro (optional)</small
                      >
                      <VueEditor
                        v-model="form.intro"
                        :editor-toolbar="customEditorToolbar"
                      ></VueEditor>

                      <div
                        v-if="videoSelected"
                        id="mainVideo"
                        class="embed-responsive embed-responsive-16by9 my-4 position-relative"
                      >
                        <div
                          class="font-weight-light text-gray h6 m-0 video-description pr-5"
                        >
                          <iframe
                            :src="videoSelected.player_url"
                            frameborder="0"
                            scrolling="no"
                            allow="autoplay; fullscreen; encrypted-media"
                            allowfullscreen
                          ></iframe>
                        </div>
                        <button
                          class="btn bg-transparent border-0 px-0 position-absolute btn-edit"
                          @click.prevent="openEpisodeLink"
                        >
                          <span class="text-primary"
                            ><BaseIcon name="edit"
                          /></span>
                        </button>
                      </div>
                      <div v-else>
                        <div class="clearfix"><br /></div>
                        <div class="clearfix"><br /></div>
                        <div class="clearfix"><br /></div>
                      </div>

                      <small class="font-weight-bold mr-2">Body</small>
                      <VueEditor
                        v-model="form.body"
                        :editor-toolbar="customEditorToolbar"
                      ></VueEditor>
                    </div>

                    <button
                      class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                      :disabled="
                        (!form.intro && !form.body) || validateCampaignLock
                      "
                      @click.prevent="validateCampaign"
                    >
                      Save & Check email
                    </button>

                    <div
                      v-if="
                        validationMatchedWords &&
                          validationMatchedWords.length > 0
                      "
                    >
                      Please try to replace or remove next words and check mail
                      template again:<br />
                      <span
                        v-for="(word, index) in validationMatchedWords"
                        :key="index"
                        class="badge badge-purple font-weight-normal mr-1 mb-1 py-1"
                        >{{ word }}</span
                      >
                      <p class="help-block"
                        ><small
                          >In some cases spam filters can reject sent mail with
                          that words or phrases.</small
                        ></p
                      >
                    </div>

                    <div
                      v-if="
                        validationMatchedWords &&
                          validationMatchedWords.length === 0
                      "
                    >
                      Cool! There are no stop words!<br />
                    </div>

                    <div v-if="validationMalicious === true"
                      >Warning! Google SafeBrowsing searched for malicious
                      links<br
                    /></div>
                    <div v-if="validationMalicious === false"
                      >Content is safe!<br
                    /></div>
                  </div>
                </div>
              </div>

              <div class="bg-white px-5 pt-4 pb-2">
                <div class="row">
                  <div class="col-sm-12 col-md-10 mx-auto">
                    <div v-if="mailTemplates">
                      <h3>Mail template:</h3>
                      <Multiselect
                        v-model="form.mailTemplate"
                        select-label="Select"
                        :allow-empty="false"
                        class="multiselect-episode-actions mx-auto"
                        :options="mailTemplates"
                        track-by="id"
                        label="title"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Mail template"
                      />
                      <br />
                    </div>
                    <h3 v-if="selectedGoogleAccounts.length > 0"
                      >Send test email to:
                    </h3>
                    <div
                      v-if="selectedGoogleAccounts.length > 0"
                      class="input-group mb-3"
                    >
                      <BaseInputText
                        v-model="form.testEmail"
                        name="testEmail"
                        type="text"
                        :placeholder="''"
                        aria-label="testEmail"
                        aria-describedby="basic-addon2"
                        class="form-control test-email"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-gray py-1"
                          :disabled="
                            form.testEmail.length === 0 || emailSending
                          "
                          @click.prevent="sendTestEmail"
                          >Send test email</button
                        >
                      </div>
                    </div>
                    <p v-if="selectedGoogleAccounts.length > 0"
                      ><br />Selected Google accounts:
                      {{ sendTestEmailsString }}</p
                    >

                    <h3 v-if="selectedSparkpostEmail">Send test email to: </h3>
                    <div v-if="selectedSparkpostEmail" class="input-group mb-3">
                      <BaseInputText
                        v-model="form.testEmail"
                        name="testEmail"
                        type="text"
                        :placeholder="''"
                        aria-label="testEmail"
                        aria-describedby="basic-addon2"
                        class="form-control test-email"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-gray py-1"
                          :disabled="
                            form.testEmail.length === 0 || emailSending
                          "
                          @click.prevent="sendTestEmail"
                          >Send test email from
                          {{ selectedSparkpostEmail.email }}</button
                        >
                      </div>
                    </div>

                    <h3 v-if="selectedSmtpEmail">Send test email to: </h3>
                    <div v-if="selectedSmtpEmail" class="input-group mb-3">
                      <BaseInputText
                        v-model="form.testEmail"
                        name="testEmail"
                        type="text"
                        :placeholder="''"
                        aria-label="testEmail"
                        aria-describedby="basic-addon2"
                        class="form-control test-email"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-gray py-1"
                          :disabled="
                            form.testEmail.length === 0 || emailSending
                          "
                          @click.prevent="sendTestEmail"
                          >Send test email from
                          {{ selectedSmtpEmail.email }}</button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                selectedGoogleAccounts.length > 0 ||
                  selectedSparkpostEmail ||
                  selectedSmtpEmail
              "
              class="bg-white pt-2 pb-4 text-center"
            >
              <div class="row">
                <div class="col-sm-12 col-md-10 mx-auto">
                  <button
                    v-if="campaign"
                    class="btn btn-primary font-weight-light px-5"
                    @click="previewCampaign"
                  >
                    Preview email
                    <span class="pl-3 float-right">
                      <BaseIcon name="external-link-alt" />
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              v-if="campaignLists && campaignLists.length !== 0"
              class="bg-light px-5 py-4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-10 mx-auto">
                  <div
                    v-if="campaign.total_leads_count > 0"
                    class="text-center mb-4"
                  >
                    <h3 class="mb-0"
                      >You are about to send
                      <span>{{ campaign.total_leads_count }}</span>
                      email<span v-if="campaign.total_leads_count > 0">s</span>,
                      are you ready?</h3
                    >
                    <h3 class="mb-0 text-purple"
                      >This costs ${{ currentCost }}. Current balance
                      <span v-if="!user.is_admin"
                        >${{ user.wallet.current_balance }}</span
                      ><span v-else> unlimited</span></h3
                    >
                    <p v-if="!videoSelected" class="text-center"
                      ><small
                        >Save ${{ currentCostDifference }} when you include a
                        video</small
                      ></p
                    >

                    <!--<small class="font-weight-light disclaimer"
                        >This will cost {{ currentCost }} USD in the
                        future. For now it's free! You're welcome
                      </small>-->
                  </div>

                  <!--
                  <div v-if="needSendTestEmail" class="text-center mb-4">
                    <h3 class="mb-0"
                      >Please preview or send a test email before starting your
                      campaign.</h3
                    >
 </div>
                  -->

                  <div
                    v-if="
                      campaign.content && campaign.content.publish_status === 0
                    "
                    class="text-center"
                  >
                    <small
                      >Your video content currently in Draft mode. We will
                      change it to Private when you will start your campaign.
                      Private mode allows accessing your content by direct
                      link.</small
                    >
                  </div>

                  <div class="text-center">
                    <button
                      class="btn btn-outline-gray font-weight-light my-3 px-4 mx-2"
                      @click.prevent="save"
                    >
                      Save campaign
                    </button>
                    <button
                      class="btn btn-outline-gray font-weight-light my-3 px-4 mx-2"
                      @click.prevent="saveAndClose"
                    >
                      Save campaign and close
                    </button>
                    <button
                      v-if="
                        (selectedGoogleAccounts.length > 0 ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail) &&
                          campaign.status === 0
                      "
                      class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                      :disabled="
                        campaign.total_leads_count === 0 ||
                          needSendTestEmail ||
                          lockStartCampaignButton
                      "
                      @click.prevent="startCampaign"
                    >
                      {{
                        !needSendTestEmail
                          ? 'Start campaign'
                          : 'Start Campaign (Preview or Test Email to Enable)'
                      }}
                    </button>
                    <button
                      v-if="
                        (selectedGoogleAccounts.length > 0 ||
                          selectedSparkpostEmail ||
                          selectedSmtpEmail) &&
                          campaign.status === 3
                      "
                      class="btn btn-primary font-weight-light my-3 px-4 mx-2"
                      :disabled="
                        campaign.total_leads_count === 0 ||
                          needSendTestEmail ||
                          lockStartCampaignButton
                      "
                      @click.prevent="startCampaign"
                    >
                      {{
                        !needSendTestEmail
                          ? 'Resume campaign'
                          : 'Resume campaign (Preview or Test Email to Enable)'
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <p v-if="!stepTwo" class="font-weight-light">
        Once your campaign is ready we will <br />
        generate a link for you to share as well
      </p>
    </div>
  </div>
</template>
